import { render } from "./CustomerSalesHistory.vue?vue&type=template&id=09fb0ed9&scoped=true"
import script from "./CustomerSalesHistory.vue?vue&type=script&lang=js"
export * from "./CustomerSalesHistory.vue?vue&type=script&lang=js"

import "./CustomerSalesHistory.vue?vue&type=style&index=0&id=09fb0ed9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fb0ed9"]])

export default __exports__